module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app-content box-shadow-z0",
    attrs: {
      "id": "content",
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "app-header grey-200 box-shadow"
  }, [_c('div', {
    staticClass: "navbar navbar-expand-lg navbar-light bg-light"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Telemetry")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Panolar")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "300px"
    }
  }, [(_vm.hasPermission('dashboards.save')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboards/save",
      "exact": ""
    }
  }, [_vm._v("Ekle")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission('dashboards.list')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboards",
      "exact": ""
    }
  }, [_vm._v("Listele")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission('dashboards.list') || _vm.hasPermission('dashboards.save')) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.dashboards), function(dashboard) {
    return (_vm.dashboardLoading == false) ? _c('li', [_c('router-link', {
      attrs: {
        "to": {
          'path': '/dashboards/' + dashboard.className,
          query: {
            id: dashboard.id
          }
        }
      }
    }, [_vm._v(_vm._s(dashboard.title))])], 1) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.hasPermission('services.save') || _vm.hasPermission('services.list')) ? _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Servisler")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.hasPermission('services.save')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/services/save",
      "exact": ""
    }
  }, [_vm._v("Ekle")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission('services.list')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/services",
      "exact": ""
    }
  }, [_vm._v("Listele")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('users.save') || _vm.hasPermission('users.list')) ? _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Kullanıcılar")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.hasPermission('users.save')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/users/save",
      "exact": ""
    }
  }, [_vm._v("Ekle")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission('users.list')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/users",
      "exact": ""
    }
  }, [_vm._v("Listele")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('api_users.save') ||  _vm.hasPermission('api_users.list')) ? _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Api Kullanıcıları")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.hasPermission('api_users.save')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/api-users/save",
      "exact": ""
    }
  }, [_vm._v("Ekle")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission('api_users.list')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/api-users",
      "exact": ""
    }
  }, [_vm._v("Listele")])], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.dashboardLoading == false) ? _c('a', {
    staticClass: "nav-link small",
    on: {
      "click": function($event) {
        _vm.refreshDashboards()
      }
    }
  }, [_vm._v("Panoları Yenile")]) : _vm._e(), _vm._v(" "), (_vm.dashboardLoading == true) ? _c('span', {
    staticClass: "nav-link small"
  }, [_vm._v("Panolar Yenileniyor...")]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle small",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.timezone))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.changeTimezone('UTC')
      }
    }
  }, [_vm._v("UTC")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.changeTimezone('Europe/Istanbul')
      }
    }
  }, [_vm._v("Europe/Istanbul")])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/users/save',
        query: {
          id: _vm.currentUser.id
        }
      }
    }
  }, [_vm._v("Bilgilerim")])], 1), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Oturumu Kapat")])])])])])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "app-body",
    attrs: {
      "id": "view"
    }
  }, [_c('div', {
    staticClass: "blue box-shadow",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_c('strong', {
    staticStyle: {
      "padding": "0px",
      "font-weight": "500",
      "font-size": "16px"
    }
  }, [_vm._t("title")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, [(_vm.loading) ? _vm._t("loading", [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.loading == false) ? _vm._t("content") : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "nav-link small"
  }, [_vm._v("|")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link clear",
    attrs: {
      "href": "",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "avatar w-32"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/profile.png"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "on b-white bottom"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "p-a text-xs"
  }, [_c('div', {
    staticClass: "pull-right text-muted"
  }, [_vm._v("\n                    © Copyright "), _c('strong', [_vm._v("Teknasyon")]), _vm._v(" "), _c('a', {
    attrs: {
      "ui-scroll-to": "content"
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-up p-x-sm"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0056d054!./~/vue-loader/lib/selector.js?type=template&index=0!./public/src/components/app_layout.vue
// module id = 332
// module chunks = 0